import { compilePlaybook } from '../../playbooks/compiler/compile-playbook';

// Runtime IDs are generated at save time. Match the stored graph to a fresh
// compilation by its edges, never by array order or message labels (which repeat).
export function runtimeStepMap(config) {
    const playbook = config?.stm?.metadata?.playbook;
    const saved = config?.stm?.stmDefinition;
    if (!playbook || !saved?.states) return {};
    const { stmDefinition: compiled, errors, stepIdByState } = compilePlaybook(playbook, { legacyConditions: Object.values(saved.states).some(state => state.stateConfig?.conditions?.length) });
    if (errors.length || !compiled) return {};
    const authoringMap = stepIdByState || {};
    const mapping = {};
    const seen = new Map();
    const reverse = new Map();
    let valid = true;
    const pair = (oldId, newId) => {
        if (!oldId && !newId) return;
        if (!oldId || !newId) { valid = false; return; }
        if (seen.has(oldId)) { if (seen.get(oldId) !== newId) valid = false; return; }
        if (reverse.has(newId) && reverse.get(newId) !== oldId) { valid = false; return; }
        seen.set(oldId, newId); reverse.set(newId, oldId);
        const oldState = saved.states[oldId];
        const newState = compiled.states[newId];
        if (!oldState || !newState) { valid = false; return; }
        const a = oldState.stateConfig || {}, b = newState.stateConfig || {};
        if (a.stateType !== b.stateType || a.type !== b.type) { valid = false; return; }
        for (const field of ['displayTextOptions', 'slot', 'slotToAssign', 'value', 'action', 'codehookId', 'journeyId', 'inputPrompt']) {
            if (JSON.stringify(a[field]) !== JSON.stringify(b[field])) { valid = false; return; }
        }
        if (authoringMap[newId]) {
            mapping[oldId] = authoringMap[newId];
            if (a.blockId) mapping[a.blockId] = authoringMap[newId];
        }
        pair(oldState.next || a.next, newState.next || b.next);
        if ((a.conditions || []).length !== (b.conditions || []).length) { valid = false; return; }
        if ((a.choices || []).length !== (b.choices || []).length) { valid = false; return; }
        (a.choices || []).forEach((choice, index) => pair(choice.next, b.choices[index].next));
        (a.conditions || []).forEach((condition, index) => pair(condition.next, b.conditions[index].next));
    };
    pair(saved.startAt, compiled.startAt);
    return valid ? mapping : {};
}

const EMPTY_SLOTS = {};
export const slotValues = (session, journeyId) => session?.slots?.[journeyId] || EMPTY_SLOTS;
export const displayValue = value => value === undefined ? 'Not set' : typeof value === 'string' ? value : JSON.stringify(value);
